// extracted by mini-css-extract-plugin
export default {"flex-column":"sidePanel_flex-column__wlqzT","side-panel":"sidePanel_side-panel__jM0Gx","flex-row":"sidePanel_flex-row__aus50","page-size":"sidePanel_page-size__1UujP"};